import { html } from "lit";
var icon_rd_placeholder_default = () => html`
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32">
    <path
      d="M16 1.5C7.992 1.5 1.5 7.992 1.5 16S7.992 30.5 16 30.5 30.5 24.008 30.5 16 24.008 1.5 16 1.5zm0 1c7.456 0 13.5 6.044 13.5 13.5S23.456 29.5 16 29.5 2.5 23.456 2.5 16 8.544 2.5 16 2.5z" />
    <path
      d="M30 13.398l.24 3.04-13.853 13.739-2.69-.61L30 13.397zm-5.067-8.743l1.83 1.736C21.418 11.91 14.52 18.613 6.074 26.502c-.319-.46-.807-1.001-1.465-1.623L24.933 4.655zM17.259 1.68L2.03 16.783l.094-3.371 11.75-11.654 3.386-.078z" />
  </svg>
`;
export {
  icon_rd_placeholder_default as default
};
//# sourceMappingURL=icon-rd-placeholder.js.map
